import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import StripeCheckout from 'react-stripe-checkout';
import { my_PUBLISHABLE_stripekey, stripeInfo } from '../../../../server/constants';
import mmLogo from './../../../../assets/img/logo1.png';
import {
    _addNotificationError,
    allowNumericWithdecimal,
    _addNotification,
    calculateStripeCharges
} from "../../../../server/util";

class StripeCheckOut extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reqObject: {},
        }
    }
    onToken = (token) => {
        const me = this;
        me.props.onToken(token.id);
    }
    render() {
        const { paymentObj, schoolName, logoUrl, schoolId, excludeCharges, disabled } = this.props;
        const _stripeInfo = stripeInfo(schoolId);
        const amount = ((paymentObj === undefined ? 0.00 : (parseFloat(paymentObj.balAmount) + (excludeCharges ? 0 : calculateStripeCharges(parseFloat(paymentObj.balAmount), undefined, schoolId)))) * (_stripeInfo.monetary_unit));
        return (<Fragment>
            <StripeCheckout
                name={schoolName == '' ? 'MealManage' : schoolName}
                //ComponentClass="div"
                panelLabel="Proceed To Pay" // prepended to the amount in the bottom pay button
                token={this.onToken}
                stripeKey={my_PUBLISHABLE_stripekey}
                amount={amount} // cents
                currency={_stripeInfo.currencyCode}
                image={(logoUrl || '') == '' ? mmLogo : logoUrl} // the pop-in header image (default none)
            >
                <button className="btn btn-success btn-sm" style={window.innerWidth <= 500 ? { width: '100%', margin: '0px 0px 0px 5px', fontSize: 14, } : { margin: '0px 0px 0px 5px', fontSize: '14px' }} disabled={disabled}>
                    <i className="glyphicon glyphicon-ok"></i>  Pay With Card
                </button>
            </StripeCheckout>
        </Fragment>)
    }
}
export default StripeCheckOut


// WEBPACK FOOTER //
// ./src/components/Misc/PaymentModule/stripe/stripeCheckOut.jsx